import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AgmCoreModule, GoogleMapsAPIWrapper } from "@agm/core";
import { DatePipe } from '@angular/common';

import { AppComponent } from './app.component';
import { MessageComponent } from './common/message.component';
import { MessageService } from './common/message.service';
import { GooglemapService } from './common/googlemap.service';
import { CommonService } from './app.service';
import { AppInterceptor } from './app.interceptor';
import { AppRoutingModule } from './app-routing.module';
import { LoginModule } from './login/login.module';
import { MemberModule } from './member-kanri/member.module';
import { CargoModule } from './cargo/cargo.module';
import { CaseModule } from './case/case.module';
import { CommonToolModule } from './common/common-tool.module';
import { MobileModule } from './mobile/mobile.module';
import { ScheduleModule } from './schedule/schedule.module';
import { NgxMyDatePickerModule } from 'ngx-mydatepicker';
import { NoticeComponent } from './notice/notice.component';
import { NoticeModule } from './notice/notice.module';
import { StatisticModule } from './statistic/statistic.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment.prod';
import { DeviceDetectorService } from 'ngx-device-detector';
import { StatementModule } from './statement/statement.module';


@NgModule({
  //そのモジュールの中で宣言されているディレクティブとパイプを登録 (モジュール内のどこでも使えるようになる)
  declarations: [
    AppComponent,
    MessageComponent
  ],
  //子モジュールを取り込む
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    AgmCoreModule.forRoot({     //Google Maps JavaScript
      apiKey: 'AIzaSyCAon3r3PeufVUJfq5vha3HY9bgBv9FT1M'
    }),
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    NgxMyDatePickerModule.forRoot(),
    LoginModule,
    MemberModule,
    CargoModule,
    CaseModule,
    MobileModule,
    ScheduleModule,
    NoticeModule,
    StatisticModule,
    StatementModule
  ],
  //そのモジュールがimportsに設定された時に提供するディレクティブとパイプを指定
  exports: [

  ],
  //トップレベルのプロバイダを宣言
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppInterceptor,
      multi: true  //必須：HTTP_INTERCEPTORSが配列であることを示す
    },
    MessageService,
    CommonService,
    DatePipe,
    DeviceDetectorService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts